var _a;
import { s } from "../chunks/namespaces-client-Q3_eBa-S.mjs";
import { otto } from "./nexus-client.mjs";
const apm = otto.apm ?? {};
const agent = apm.agent;
const getCurrentTransaction = apm.getCurrentTransaction;
const startSpan = apm.startSpan;
const captureError = apm.captureError;
const mark = apm.mark;
const addLabels = apm.addLabels;
const sendCustomError = apm.sendCustomError;
const apmSync = ((_a = s) == null ? void 0 : _a.apm) ?? {};
const runWithSpan = apmSync.runWithSpan;
const withSpan = apmSync.withSpan;
export {
  addLabels,
  agent,
  apm,
  apmSync,
  captureError,
  getCurrentTransaction,
  mark,
  runWithSpan,
  sendCustomError,
  startSpan,
  withSpan
};
/*                                   */
